/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBrandListModel
 */
export interface GetBrandListModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetBrandListModel
     */
    categoryIds?: Array<number> | null;
}

export function GetBrandListModelFromJSON(json: any): GetBrandListModel {
    return GetBrandListModelFromJSONTyped(json, false);
}

export function GetBrandListModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrandListModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryIds': !exists(json, 'categoryIds') ? undefined : json['categoryIds'],
    };
}

export function GetBrandListModelToJSON(value?: GetBrandListModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryIds': value.categoryIds,
    };
}

